import React from "react";

import { ViewTitle } from "./styled";

export interface DiaryHeaderTitleProps {
  title?: string;
}
export const DiaryHeaderTitle = (props: DiaryHeaderTitleProps) => {
  const { title } = props;

  return <ViewTitle>{title}</ViewTitle>;
};
